import * as React from 'react'
import { FlatButton, SelectField, MenuItem, DropDownMenu } from 'material-ui'
import { Link, RouteComponentProps } from 'react-router-dom'
import { RouterAction, routerActions } from 'react-router-redux'
import { connect, Dispatch } from 'react-redux'
import { AppBarContainer } from './CustomAppBar'
import { LinedText } from '../components/LinedText'
import { StarRatings } from '../components/StarRating'
import { ButtonInfo, ButtonGroup } from '../components/ButtonGroup'
import { JobDetails, HaulerInfo } from '../components/JobDetails'
import { ReviewTitle } from '../components/ReviewTitle'
import PageTitle from '../components/PageTitle'
import { Api } from '../services/api/api'
import DateUtils from '../utils/DateUtils'
import { DEFAULT_ROUTE, ROUTES } from '../constants/routes'
import * as Constants from '../constants/containers/ReviewHaulerContainer'
import { Compliment, Job } from '../types'
import { RatingCreatorType } from '../types/enums'
import { StoreState } from '../reducers'
import '../styles/App.scss'
import '../styles/ReviewHauler.scss'
import { removeJobDetails } from '../actions/setJobDetails'
import { StickyContainer, Sticky } from 'react-sticky'
import { AdditionalItemStatus } from '../types/enums/AdditionalItemStatus'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'
import {
    Actions as JobActions,
    ActionType as JobActionType
} from '../actions/job'

import * as ApiConf from '../config/api'
import {
    FacebookShareButton,
    FacebookIcon,
    LinkedinShareButton,
    TwitterShareButton
} from 'react-share'

import Select from 'react-select'
import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
    ActionType as ErrorInfoActionType,
    Actions as ErrorActions
} from '../actions/errorInfo'
import { Error as ErrorInfo } from '../types/Errors/Error'
import Mapper from '../utils/Mapper'

interface ReviewHaulerState {
    isRateSelected: boolean
    rateValue: number
    compliments: Compliment[]
    reasons: string[]
    reason?: string
    haulerInfo: HaulerInfo
}

export interface ReviewHaulerProps {
    job: Job
    routePush: (location: string) => RouterAction
    jobId: string
    removeJobDetails: () => void
    removeJob: () => JobActionType
    onErrorEvent: (errorInfo: ErrorInfo) => ErrorInfoActionType
}

type Props = ReviewHaulerProps & RouteComponentProps<any>

export class ReviewHauler extends React.Component<Props, ReviewHaulerState> {
    constructor(props: any) {
        super(props)
        this.state = {
            isRateSelected: false,
            rateValue: 0,
            compliments: [],
            reason: undefined,
            reasons: [],
            haulerInfo: {
                company: '',
                avatar: '',
                price: null,
                completed: undefined,
                enabledIndependent: false,
                haulerName: ''
            }
        }
    }

    componentDidMount() {
        Api.getCompliments()
            .then((compliments: Compliment[]) => {
                this.setState({
                    compliments: compliments
                })
            })
            .catch(error => {
                this.props.onErrorEvent(Mapper.mapError(error))
                console.log('Error on downloading compliments: ', error)
            })
        Api.getTagsRating()
            .then((ratingTags: string[]) => {
                this.setState({
                    reasons: ratingTags
                })
            })
            .catch(error => {
                this.props.onErrorEvent(Mapper.mapError(error))
                console.log('Error on downloading rating tags: ', error)
            })
        Api.getJob(this.props.jobId).then((result: any) => {
            let price =
                result.additionalItem &&
                (result.additionalItem.status ===
                    AdditionalItemStatus.ACCEPTED ||
                    result.additionalItem.status ===
                        AdditionalItemStatus.CHARGED)
                    ? result.amount + result.additionalItem.amount
                    : result.amount

            this.setState({
                haulerInfo: {
                    company: result.hauler.companyId,
                    completed: result.completeDate,
                    price: price,
                    avatar: result.hauler.avatar,
                    enabledIndependent: result.enabledIndependent,
                    haulerName: `${result.hauler.firstName} ${result.hauler.lastName}`
                }
            })
        })
    }

    onRateSelected = (nextValue: number) => {
        this.setState({
            rateValue: nextValue
        })
    }

    onReasonSelected = (reason: string) => {
        this.setState({
            reason: reason
        })
    }

    onComplimentSelected = (compliment: string) => {
        this.setState({
            reason: compliment
        })
    }

    confirm = () => {
        let createTime = DateUtils.getDateAsNumber(new Date())
        Api.submitRating({
            jobId: this.props.jobId,
            // clientId: this.props.job.clientId,
            // creator: RatingCreatorType.CLIENT,
            // haulerId: this.props.job.hauler ? this.props.job.hauler.username : '',
            stars: this.state.rateValue,
            message:
                this.state.reason !== undefined ? this.state.reason : undefined
            // createDate: createTime,
            // modifyDate: createTime
        })
            .then(result => {
                this.props.removeJobDetails()
                this.props.removeJob()
                this.props.routePush(DEFAULT_ROUTE)
            })
            .catch(error => {
                this.props.onErrorEvent(Mapper.mapError(error))
                console.log(error)
            })
    }

    mapReasonsToButtonInfo = (): ButtonInfo[] => {
        let result: ButtonInfo[] = []
        this.state.reasons.map((value: string, index: number) => {
            result.push({
                id: index,
                title: value
            })
        })
        return result
    }

    handleSkip = () => {
        this.props.removeJobDetails()
        this.props.removeJob()
        this.props.routePush(DEFAULT_ROUTE)
    }

    componentWillUnmount() {
        this.props.removeJobDetails()
    }

    render() {
        let shareUrl = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.POST_MESSAGE
        )
        const fromHistory =
            !!this.props.location.state &&
            this.props.location.state['fromHistory']

        const selectFn = (event: any, index: any, value: any) => {
            this.onComplimentSelected(event.value)
        }

        let compliments = this.state.compliments.map(compliment => {
            return { value: compliment.title, label: compliment.title }
        })

        return (
            <BaseContainer pageName={EventType.REVIEW_HAULER}>
                <AppBarContainer
                    isIconButtonsShown={fromHistory}
                    isMenuShown={false}
                    resetStore={fromHistory}
                />
                <PageTitle
                    text={StringResources.getString(
                        Strings.ReviewProvider.Title
                    )}
                />
                <PerfectScrollbar className="vertical-scrollbar rh">
                    <JobDetails haulerInfo={this.state.haulerInfo} />
                    <div className="starRatingContainer">
                        <StarRatings
                            onClick={this.onRateSelected}
                            initialRating={this.state.rateValue}
                            className=""
                        />
                    </div>
                    <ReviewTitle
                        title={Constants.Titles[this.state.rateValue].title}
                        subTitle={
                            Constants.Titles[this.state.rateValue].subTitle
                        }
                    />
                    <div>
                        {this.state.rateValue > 0 &&
                            this.state.rateValue <= 4 && (
                                <ButtonGroup
                                    buttons={this.mapReasonsToButtonInfo()}
                                    buttonsPerLine={Constants.ButtonsPerLine}
                                    multiple={true}
                                    onChanged={this.onReasonSelected}
                                />
                            )}
                        {this.state.rateValue === 5 && (
                            <div className="socialContainer">
                                <div className="title">
                                    {StringResources.getString(
                                        Strings.ReviewProvider.SubTitles
                                            .ShareLove
                                    )}
                                </div>
                                <div className="social">
                                    <FacebookShareButton
                                        url={shareUrl}
                                        quote="Curb-it is Amazing!"
                                        className="shareBtn"
                                    >
                                        <div className="icon facebook" />
                                    </FacebookShareButton>

                                    <TwitterShareButton
                                        url={shareUrl}
                                        quote="Curb-it is Amazing!"
                                        className="shareBtn"
                                    >
                                        <div className="icon twitter" />
                                    </TwitterShareButton>

                                    <LinkedinShareButton
                                        url={shareUrl}
                                        quote="Curb-it is Amazing!"
                                        className="shareBtn"
                                    >
                                        <div className="icon linkedin" />
                                    </LinkedinShareButton>
                                </div>
                                <div className="title">
                                    {StringResources.getString(
                                        Strings.ReviewProvider.SubTitles
                                            .Compliment
                                    )}
                                </div>
                                <div className="time-select">
                                    <Select
                                        className={'input-long'}
                                        onChange={selectFn}
                                        options={compliments}
                                        placeholder={StringResources.getString(
                                            Strings.ReviewProvider.DropDowns
                                                .Compliment.placeholder
                                        )}
                                        menuPlacement="bottom"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </PerfectScrollbar>
                {!fromHistory && (
                    <div className="skip">
                        <a>
                            <span onClick={this.handleSkip}>
                                {StringResources.getString(
                                    Strings.ReviewProvider.Links.SkipRating.text
                                )}
                            </span>
                        </a>
                    </div>
                )}
                <StickyContainer className="sticky-footer sb">
                    <Sticky>
                        {() => (
                            <div className="bottom-part hover">
                                <div className="confirm">
                                    <FlatButton
                                        onClick={this.confirm}
                                        className="flatbutton"
                                        label={StringResources.getString(
                                            Strings.ReviewProvider.Buttons
                                                .Submit.label
                                        )}
                                    />
                                </div>
                            </div>
                        )}
                    </Sticky>
                </StickyContainer>
            </BaseContainer>
        )
    }
}

function mapStateToProps(state: StoreState) {
    return {
        routing: state.routing,
        job: state.currentJob,
        jobId: state.jobDetails.jobId
    }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
    return {
        routePush: (location: string) => dispatch(routerActions.push(location)),
        removeJobDetails: () => dispatch(removeJobDetails()),
        onErrorEvent: (errorInfo: ErrorInfo) =>
            dispatch(ErrorActions.newError(errorInfo)),
        removeJob: () => dispatch(JobActions.createJob(null))
    }
}

export const ReviewHaulerContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ReviewHauler)



// WEBPACK FOOTER //
// ./src/containers/ReviewHaulerContainer.tsx